module.exports = __webpack_public_path__ + "img/Knewin-Logo.9a4d7557.svg";